import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { ReadbackRequest, ReadbackResponseItem } from "@/types/cppt";

async function create(data: ReadbackRequest) {
  const response = await http.postData("/readback", data).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data.data;
}

async function update(id, data: ReadbackRequest) {
  const response = await http.putData(`/readback/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data.data;
}

async function getByRegister(
  register_id: string | number
): Promise<{ status: number; data: ReadbackResponseItem[] }> {
  const response = await http
    .getData(`/register/${register_id}/readback`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function find(id: number) {
  const response = await http.getData(`/readback/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data.data;
}

async function destroy(id, alasan) {
  const response = await http
    .deleteDataParam(`/readback/${id}`, {
      params: {
        alasan: alasan
      }
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function verifyByConsultant(id, data = undefined) {
  const response = await http
    .postData(`/readback/${id}/verifikasi-consultant`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function verify(id, data = undefined) {
  const response = await http
    .postData(`/readback/${id}/verifikasi`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

export default {
  create,
  update,
  getByRegister,
  find,
  destroy,
  verifyByConsultant,
  verify
};
